import { OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PagedResult } from '../../../../@AppService/Models/PagedResult';
import { PagingModel } from '../../../../@AppService/Models/PagingModel';
import { PagingService } from '../../../../@AppService/Services/PagingService';



export class BaseComponent {
  token: string = '';
  isAuthorized = false;
  pagingModel: PagingModel;
  finishLoading = false;
  constructor(
    public route: Router,
    public service: any,
    public pagingService: PagingService = {} as PagingService,
    moduleName: string = '',
  ) {
    this.pagingModel = new PagingModel();
    // this.token = localStorage.getItem('e-serviceToken');
    if (this.token != null) this.isAuthorized = true;
    // if (this.token == null) {
    //   this.route.navigate(['/auth/login']);
    // } else this.isAuthorized = true;
  }

 

  loadEntities() {
    this.service.get(this.pagingModel.query).subscribe ((res: any)  => {
      this.initiResponse(res);
      this.finishLoading = true;
    });
  }

  authorize(permission: string) {
    if (this.token != null) return true;
    else return false;
  }

  authenticate() {
    if (this.token == null) {
      this.route.navigate(['/login']);
    }
  }

  initiResponse(result: PagedResult) {
    this.pagingModel.responseObj = result.result;
    this.pagingModel.responseData = result;
    this.pagingModel.pager = Array.from(
      { length: result.totalPages },
      (v, k) => k + 1,
    );
    this.pagingModel.totalPages = result.totalPages;
  }
}
